/**
 * Where a connector row's Connect goes — the one pure decision, so it can be tested without the data
 * layer (`lib/connectors.ts` pulls `api-client`, which reaches common-lib and cannot be imported from a
 * jest test — see orion-web/CLAUDE.md → Tests). Same shape as native's `connectorConnectRoute`.
 *
 * `connectVia` is the server's per-row override, so a connector whose connect belongs in a conversation
 * can say so as DATA rather than as a `provider` value each client would have to learn. That is what lets
 * a new connector reach all three surfaces without a client change. It outranks every rail below except
 * the native calendar one — see the guard.
 *
 * The `mcp` line is where web deliberately DIVERGES from the phones: they open the authorize URL this
 * server mints, web hands the row to the assistant so the prerequisite is explained in the user's own
 * language first. Both end at the same vendor screen.
 */
export type ConnectorConnectRouteName = 'native-calendar' | 'assistant-chat' | 'composio';

/** The minimal shape the rule reads — `ConnectorStatus` satisfies it structurally. */
export type ConnectRouteConnector = {
  provider?: string;
  connectVia?: string;
};

export function connectorConnectRoute(connector: ConnectRouteConnector): ConnectorConnectRouteName {
  // The one rail the override may NOT move. A calendar row connects through a device-level flow —
  // Google sign-in, a hosted Microsoft page, an iCloud app password — and a conversation cannot perform
  // any of them, so an override landing here by mistake would strand the row instead of explaining it.
  // Nothing legitimately sets one on a calendar row: they are synthesized server-side from a fixed list
  // of three, and the override is written only for the partner-install rail.
  if (connector.provider === 'native') {
    return 'native-calendar';
  }
  if (connector.connectVia === 'assistant-chat') {
    return 'assistant-chat';
  }
  if (connector.provider === 'mcp' || connector.provider === 'wix-service') {
    return 'assistant-chat';
  }
  return 'composio';
}
